import styled from "@emotion/styled"

import { minTabletMediaQuery } from "theme/media-queries"

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-color: 1px red solid;
  gap: 10px;

  ${minTabletMediaQuery} {
    flex-direction: row;
  }
`

export const Button = styled.button`
  background-color: ${p => p.theme.colors.primaryMedium};
  ${p => p.theme.typography.standard.size_14px.semibold()}
  color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.primaryMedium};
  border-radius: 2px;
  padding: 12px 40px;
  max-width: 800px;
  width: 100%;
  max-height: 50px;
  height: 100%;

  :hover {
    cursor: pointer;
    background-color: ${p => p.theme.colors.primaryDark};
  }

  :active {
    background-color: ${p => p.theme.colors.primaryExtraDark};
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${minTabletMediaQuery} {
    margin-left: 10px;
    max-width: 140px;
  }
`
export const SuccessMessage = styled.p<{ show: boolean }>`
  background-color: ${p => p.theme.colors.successExtraLight};
  ${p => p.theme.typography.standard.size_14px.normal()}
  color: ${p => p.theme.colors.successMedium};
  border: 1px solid ${p => p.theme.colors.successMedium};
  border-radius: 2px;
  padding: 14px 10px;
  max-width: 320px;
  margin: 0 auto;
`
